import React from 'react'
import classNames from 'classnames'

export const Kbd = ({ size = 'base', children, className, ...props }) => {
  const classes = [
    'border',
    'border-gray-300',
    'p-1',
    'rounded-sm',
    'shadow-sm',
    'font-mono',
    'font-medium',
    'bg-gray-100',
    'text-gray-500',
    'capitalize',
  ]


  classes.push({
    xs: 'text-xs',
    sm: 'text-sm',
    base: '',
  }[size] ?? '')

  let style = {}

  if (size === 'xxs') {
    style = { 
      fontSize: '0.625rem'
    }
  }

  return (
    <kbd {...props} className={classNames(classes, className)} style={style}>
      { children }
    </kbd>
  )
}

export default Kbd
